import { z } from "zod";
import { useQueryClient } from "@tanstack/react-query";
import { api } from "../api/client";
import { keys } from "../api/hooks";
import { Button, Panel } from "../components/ui";

export function NoAccessPage({ email }: { email: string }) {
  const qc = useQueryClient();
  const signOut = async () => { await api("/auth/logout", z.undefined(), { method: "POST" }); qc.setQueryData(keys.me, null); };
  return (
    <main className="flex min-h-screen items-center justify-center bg-hs-surface-alt p-4">
      <Panel className="w-full max-w-md">
        <h1 className="text-xl font-semibold text-hs-text">No locations linked yet</h1>
        <p className="mt-2 text-sm">You signed in as <strong>{email}</strong>, but that account is not linked to any Hello Sugar locations.</p>
        <p className="mt-2 text-[13px] text-hs-text-muted">If you own locations, contact corporate and ask them to link this email. If you have another Google account, sign out and try that one.</p>
        <Button variant="secondary" className="mt-5" onClick={signOut}>Sign out</Button>
      </Panel>
    </main>
  );
}
